(() => {
    "use strict";

    const getStoredTheme = () => localStorage.getItem("theme");
    const setStoredTheme = (theme) => localStorage.setItem("theme", theme);

    const getPreferredTheme = () => {
        const storedTheme = getStoredTheme();
        if (storedTheme) return storedTheme;
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    };

    const setTheme = (theme) => {
        if (theme === "auto") {
            document.documentElement.setAttribute("data-bs-theme", 
                window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
        } else {
            document.documentElement.setAttribute("data-bs-theme", theme);
        }
    };

    const showActiveTheme = (theme, focus = false) => {
        const themeSwitcher = document.querySelector("#bd-theme");
        if (!themeSwitcher) return;

        const activeThemeIcon = themeSwitcher.querySelector(".theme-icon-active");
        const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`);
        
        if (!activeThemeIcon || !btnToActive) return;

        const svgElement = btnToActive.querySelector("[data-fi]");
        if (!svgElement) return;

        // Update all buttons
        document.querySelectorAll("[data-bs-theme-value]").forEach((element) => {
            element.classList.remove("active");
            element.setAttribute("aria-pressed", "false");
            element.querySelector(".fi-check2").classList.add("d-none");
        });

        // Activate current button
        btnToActive.classList.add("active");
        btnToActive.setAttribute("aria-pressed", "true");
        btnToActive.querySelector(".fi-check2").classList.remove("d-none");
        
        // Update icon in main button
        activeThemeIcon.dataset.fi = svgElement.dataset.fi;
        activeThemeIcon.className = `bi fi-${svgElement.dataset.fi} my-1 theme-icon-active`;
        
        // Update aria-label with the selected theme
        const themeText = btnToActive.textContent.trim().replace(/\s+/g, ' ').split(' ')[0];
        themeSwitcher.setAttribute("aria-label", `Toggle theme (${themeText})`);

        if (focus) {
            themeSwitcher.focus();
        }
    };

    // Initialize theme
    setTheme(getPreferredTheme());

    // Watch for system theme changes
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
        const storedTheme = getStoredTheme();
        if (storedTheme !== "light" && storedTheme !== "dark") {
            setTheme(getPreferredTheme());
            showActiveTheme(getPreferredTheme());
        }
    });

    // Set up event listeners when DOM is loaded
    window.addEventListener("DOMContentLoaded", () => {
        showActiveTheme(getPreferredTheme());

        document.querySelectorAll("[data-bs-theme-value]").forEach((toggle) => {
            toggle.addEventListener("click", () => {
                const theme = toggle.getAttribute("data-bs-theme-value");
                setStoredTheme(theme);
                setTheme(theme);
                showActiveTheme(theme, true);
            });
        });
    });
})();
